import React from "react";
import { DateTime } from "luxon";
import MoreActionRenderer from "../../../dumb-components/documents/grid/more-action-renderer";
import FolderNameRenderer from "./folder-name-renderer";
import { BellRing, CalendarClock, Dot, Mail, PenTool } from "lucide-react";
import Tooltip from "@/components/tooltip";
import LoadingPanel from "@/components/loadingPanel";

export function documentListColumnDefs(t) {
  const columnDefs = [
    {
      field: "group",
      rowGroup: true,
      hide: true,
      valueFormatter: (params) => {
        return t(params.value);
      },
    },
    {
      field: "metadata",
      maxWidth: 48,
      minWidth: 48,
      cellStyle: () => {
        return {
          padding: "0px",
        };
      },
      cellRenderer: (params) => {
        if (!params.data?.metadata) {
          return null;
        }

        const {
          metadata: { documentIsSigned, ongoingEsigning },
        } = params.data;

        let signingStatusIcon = null;

        if (documentIsSigned) {
          signingStatusIcon = (
            <Tooltip
              value={t("documents.esign.signatories.signed.list.header.date")}
            >
              <PenTool size={16} strokeWidth={2} className="text-success" />
            </Tooltip>
          );
        } else if (ongoingEsigning) {
          signingStatusIcon = (
            <Tooltip
              value={t(
                "meeting.protocol_edit.tabs.tooltip.disabled_due_to_signing",
              )}
            >
              <Mail size={16} strokeWidth={2} className="text-slate-400" />
            </Tooltip>
          );
        }

        const status = params.data?.metadata?.status;
        let statusIcon = (
          <Tooltip value={params.data?.title}>
            <Dot size={16} strokeWidth={5} className="text-slate-200" />
          </Tooltip>
        );

        if (status === "INVALID") {
          statusIcon = (
            <Tooltip value={t("company.documents.renewal_date.expired")}>
              <CalendarClock size={16} className="text-red-400" />
            </Tooltip>
          );
        } else if (status === "WARNING") {
          statusIcon = (
            <div>
              <Tooltip value={t("documents.reminder.expired")}>
                <BellRing
                  size={16}
                  strokeWidth={2.5}
                  className="text-orange-400"
                />
              </Tooltip>
            </div>
          );
        }

        return (
          <div className="flex h-full w-full items-center justify-start gap-1 pl-4 leading-[16px]">
            <div>{statusIcon}</div>
            <div>{signingStatusIcon}</div>
          </div>
        );
      },
    },
    {
      field: "date",
      maxWidth: 105,
      minWidth: 105,
      valueFormatter: (params) => {
        if (!params.value) {
          return "";
        }

        const dt = DateTime.fromISO(params.value);
        return dt.toLocaleString();
      },
      cellRenderer: (params) => {
        if (!params.data) {
          return null;
        }

        if (params.data.isUploading) {
          return <LoadingPanel />;
        }

        if (!params.value) {
          return "";
        }

        const dt = DateTime.fromISO(params.value);
        return (
          <div className="flex h-full items-center text-slate-500">
            {dt.toLocaleString()}
          </div>
        );
      },
    },
    {
      field: "title",
      filter: "agSetColumnFilter",
      cellRenderer: (params) => {
        if (!params.data) {
          return null;
        }

        const { title } = params.data;

        if (title) {
          return <FolderNameRenderer props={params} />;
        }

        return null;
      },
    },
    {
      field: "moreAction",
      maxWidth: 44,
      minWidth: 44,
      cellRenderer: (params) => <MoreActionRenderer props={params} />,
      cellClass: "more-action-btn-icon",
    },

    //! These columns are only to make the search field above the list to work when searching for folder or tag
    {
      field: "metadata.folderName.sv",
      hide: true,
      filter: "agSetColumnFilter",
    },
    {
      field: "tags",
      hide: true,
      filter: "agSetColumnFilter",
    },
  ];
  return columnDefs;
}
